import { Component } from '@angular/core';
import { ApiService } from '../services/api.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true
})
export class FooterComponent {

  constructor(
    public apiService : ApiService,
    ){

    }

}
